<template>
  <BaseModal @close="$emit('close')" cardWidth="480px" noPadding noToolbar noExit>
    <template #default>
      <!-- Header -->
      <div class="relative w-full flex gap-2 p-5 border-b border-border-normal">
        <QuestionMarkCircleIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Learn about attribution window in Lens
        </BaseText>
        <button class="absolute top-3 right-3 w-6 h-6 flex items-center justify-center"
        @click="$emit('close')">
          <TagRemoveIcon stroke="#5A667C" :width="16" :height="16" />
        </button>
      </div>
      <!-- Body -->
      <div class="w-full flex flex-col p-5">
        <BaseText type="body" size="xs" class="text-text-normal">
          The attribution window is the time frame in which a user action can be credited for a conversion. It helps track the effectiveness of your campaigns.
        </BaseText>
        <BaseText type="body" size="xs" class="text-text-normal mt-3">
          For Meta ads, you may change the attribution window on the fly within Lens either here or within a report. Your data will be updated in real-time.
        </BaseText>
        <BaseText type="body" size="xs" class="text-text-normal mt-3">
          The TikTok ads API does <span class="font-bold">not</span> support changing the attribution window. TikTok ads displayed in Lens will use the attribution window defined on the ad set within TikTok Ads Manager.
        </BaseText>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import QuestionMarkCircleIcon from '../../globals/Icons/QuestionMarkCircleIcon.vue'
import TagRemoveIcon from '../../globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'AttributionWindowDisclaimerModal',
  components: {
    QuestionMarkCircleIcon,
    TagRemoveIcon
  }
}
</script>